"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const licenses_1 = require("@completeanatomy/licenses");
const ui_1 = require("@completeanatomy/ui");
const user_1 = require("@completeanatomy/user");
const PrimaryButton_1 = require("../../atoms/PrimaryButton");
const styled_components_1 = __importStar(require("styled-components"));
const image = require('../../assets/store-baked-image.png');
const image2x = require('../../assets/store-baked-image@2x.png');
function StoreTrialPanel() {
    const currentUser = (0, user_1.useUser)();
    const userLicenses = (0, licenses_1.useUserLicenses)();
    const hasTrial = (0, licenses_1.isTrialLicenses)(userLicenses);
    const onTry = () => {
        var _a;
        if (!(currentUser === null || currentUser === void 0 ? void 0 : currentUser.identifier)) {
            //@ts-ignore -- navigates back to store page.
            window.navigateBack = true;
        }
        // @ts-ignore - @todo Replace with modules when ready
        (_a = window.onTryTrial) === null || _a === void 0 ? void 0 : _a.call(window);
    };
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'StoreTrialPanel_Container', children: [(0, jsx_runtime_1.jsx)(Background, { image: [`/${image.default}`, `/${image2x.default}`], "data-e2e": 'StoreTrialPanel_Background', children: (0, jsx_runtime_1.jsx)(Overlay, { "data-e2e": 'StoreTrialPanel_Overlay' }) }), (0, jsx_runtime_1.jsx)(Content, { "data-e2e": 'StoreTrialPanel_Content', children: currentUser ? ((0, jsx_runtime_1.jsx)(LoggedInTitle, { "data-e2e": 'StoreTrialPanel_LoggedInTitle', children: (0, i18n_1.Localized)(i18n_1.Strings.store.trial.title) })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(LoggedOutTitle, { "data-e2e": 'StoreTrialPanel_LoggedOutTitle', children: (0, i18n_1.Localized)(i18n_1.Strings.store.trial.title) }), (0, jsx_runtime_1.jsx)(SubTitle, { "data-e2e": 'StoreTrialPanel_SubTitle', children: (0, i18n_1.Localized)(i18n_1.Strings.store.trial.subtitle) }), (0, jsx_runtime_1.jsx)(TryButton, { onClick: onTry, "data-e2e": 'StoreTrialPanel_TryButton', children: (0, i18n_1.Localized)(i18n_1.Strings.store.trial.button) }), !hasTrial && (0, jsx_runtime_1.jsx)(Hint, { "data-e2e": 'StoreTrialPanel_Hint', children: (0, i18n_1.Localized)(i18n_1.Strings.store.trial.hint) })] })) })] }));
}
exports.default = StoreTrialPanel;
const Container = styled_components_1.default.div `
  position: relative;

  display: flex;
  flex-shrink: 0;

  width: 100%;
  height: 220px;

  ${ui_1.deviceLandscape.mobileS((0, styled_components_1.css) `
    height: 160px;
  `)};

  ${ui_1.device.tablet((0, styled_components_1.css) `
    height: 220px;
  `)};
`;
const Background = (0, styled_components_1.default)(ui_1.BackgroundImage) `
  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;

  overflow: hidden;

  background-position: 0 -50px;
  background-size: cover;
`;
const Overlay = styled_components_1.default.div `
  position: absolute;

  top: 0;
  right: 0;
  left: 0;

  width: 100%;
  height: 100%;

  background: ${props => props.theme.store.trialBackground};
`;
const Content = styled_components_1.default.div `
  position: relative;

  display: flex;
  flex-direction: column;

  margin: 0 auto;
`;
const LoggedInTitle = styled_components_1.default.div `
  margin: auto;

  color: #f3f3f3;

  font-size: 24px;
  text-align: center;
`;
const LoggedOutTitle = (0, styled_components_1.default)(LoggedInTitle) `
  margin: auto auto 0 auto;
`;
const SubTitle = styled_components_1.default.div `
  margin: 5px auto 30px auto;

  color: #f3f3f3;

  font-size: 14px;
  text-align: center;
`;
const TryButton = (0, styled_components_1.default)(PrimaryButton_1.PrimaryButton) `
  width: 240px;

  margin: 0 auto auto auto;
  padding: 15px 0;

  font-size: 18px;

  border-radius: 3px;

  &:focus-visible {
    outline: ${({ theme }) => `2px solid ${theme.greenSecondary}`};
    outline-offset: 3px;
  }
`;
const Hint = styled_components_1.default.div `
  font-size: 12px;
  text-align: center;
  color: ${({ theme }) => theme.text};
`;
